/**
 * UserPeriodListContainer
 * --
 */
import React from 'react';
import UserPeriodListPresenter from './UserPeriodListPresenter';
import { useNavigate } from 'react-router-dom';
import useUpdateQuery from 'utils/useUpdateQuery';

const UserPeriodListContainer = (props) => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  /* ===== PROPS ===== */
  /* ===== DATA ===== */
  /* ===== STATE ===== */
  const [searchInputValue, setSearchInputValue] = React.useState({});
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  // 쿼리 업데이트
  const updateQuery = useUpdateQuery();
  /**
   * 데이터 바인딩
   * --
   * @param {string} t
   * @param {string | number | boolean} v
   * @param {func} callback
   */
  const handleChange = (t, v, callback = null) => {
    setSearchInputValue((prevState) => {
      const newData = { ...prevState, [t]: v };

      if (callback) callback(v);

      return newData;
    });
  };
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <UserPeriodListPresenter
        onChange={handleChange}
        navigate={navigate}
        searchInputValue={searchInputValue}
        onUpdateQuery={updateQuery}
      />
    </>
  );
};

export default UserPeriodListContainer;
